import React, { useState, useEffect, useRef } from 'react';

const cores = {
  orange: '#D85A30',
  border: '#d4dde8',
  bg: '#f5f7fa',
  muted: '#6b7a8d',
  navy: '#1A2233',
};

const perfisLabel = { func: 'Funcionario', fin: 'Financeiro', ges: 'Gestor' };
const perfisBadge = {
  func: { background: 'rgba(255,255,255,0.15)', color: 'white' },
  fin:  { background: '#D85A30', color: 'white' },
  ges:  { background: '#27ae60', color: 'white' },
};

export default function Layout({
  usuario, onLogout, children, abas, abaAtiva, onAba,
  pushStatus, onAtivarPush, mostrarPush,
}) {
  const [largura, setLargura] = useState(window.innerWidth);
  const [menuAberto, setMenuAberto] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handle = () => setLargura(window.innerWidth);
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);

  const isMobile = largura < 600;

  // No celular, o menu sempre abre ao tocar — mesmo sem opção de notificação,
  // ele mostra o motivo (em vez de simplesmente não fazer nada, o que confunde).
  const exibirMenuMobile = isMobile;
  const exibirOpcaoNotificacao = isMobile && mostrarPush;

  // Fecha o menu ao clicar fora dele
  useEffect(() => {
    if (!menuAberto) return;
    const handleClickFora = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuAberto(false);
      }
    };
    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, [menuAberto]);

  const textoPush = {
    indefinido:   '🔔 Ativar notificações',
    ativando:     '🔔 Ativando...',
    ativado:      '✅ Notificações ativadas',
    negado:       '🔕 Notificações bloqueadas',
  }[pushStatus] || '🔔 Ativar notificações';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: cores.bg }}>

      {/* TOPBAR */}
      <div style={{
        background: cores.navy, color: 'white',
        padding: '0 12px', height: 52,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        position: 'sticky', top: 0, zIndex: 100,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
      }}>
        {/* LOGO */}
        <img src="/logo_menu.png" alt="Sobraa" onClick={() => window.location.reload()} style={{ height: 28, objectFit: 'contain', flexShrink: 0, cursor: 'pointer' }} />

        {/* DIREITA */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div ref={menuRef} style={{ position: 'relative' }}>
            <button
              type="button"
              disabled={!isMobile}
              onClick={() => setMenuAberto(v => !v)}
              style={{
                display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden',
                background: 'transparent', border: 'none', padding: '6px 4px',
                cursor: isMobile ? 'pointer' : 'default', WebkitTapHighlightColor: 'transparent',
              }}
            >
              <div style={{
                width: 28, height: 28, borderRadius: '50%',
                background: cores.orange,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 700, fontSize: 11, color: 'white', flexShrink: 0
              }}>
                {usuario?.iniciais || usuario?.nome?.slice(0,2).toUpperCase()}
              </div>
              {!isMobile && (
                <span style={{ fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {usuario?.nome}
                </span>
              )}
              <span style={{
                fontSize: 10, fontWeight: 700, padding: '2px 7px',
                borderRadius: 20, textTransform: 'uppercase',
                whiteSpace: 'nowrap', flexShrink: 0,
                ...perfisBadge[usuario?.perfil]
              }}>
                {perfisLabel[usuario?.perfil]}
              </span>
            </button>

            {/* MENU — abre no celular ao tocar no avatar */}
            {exibirMenuMobile && menuAberto && (
              <div style={{
                position: 'absolute', top: '130%', right: 0,
                background: 'white', borderRadius: 8,
                boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                minWidth: 220, zIndex: 200, overflow: 'hidden',
                border: `1px solid ${cores.border}`,
              }}>
                {exibirOpcaoNotificacao ? (
                  <>
                    <button
                      onClick={() => {
                        setMenuAberto(false);
                        if (pushStatus !== 'ativado' && pushStatus !== 'ativando' && onAtivarPush) onAtivarPush();
                      }}
                      disabled={pushStatus === 'ativando' || pushStatus === 'ativado'}
                      style={{
                        width: '100%', textAlign: 'left', padding: '12px 14px',
                        background: 'white', border: 'none', fontSize: 13,
                        color: cores.navy, fontWeight: 500,
                        cursor: (pushStatus === 'ativado' || pushStatus === 'ativando') ? 'default' : 'pointer',
                      }}
                    >
                      {textoPush}
                    </button>
                    {pushStatus === 'negado' && (
                      <div style={{ padding: '0 14px 12px', fontSize: 11, color: cores.muted, lineHeight: 1.4 }}>
                        Bloqueado pelo navegador. Para ativar, toque no ícone de cadeado/informações ao lado do endereço do site e permita notificações.
                      </div>
                    )}
                  </>
                ) : (
                  <div style={{ padding: '12px 14px', fontSize: 12, color: cores.muted, lineHeight: 1.4 }}>
                    Notificações não disponíveis para o seu perfil neste momento.
                  </div>
                )}
              </div>
            )}
          </div>

          <button onClick={onLogout} style={{
            background: 'rgba(255,255,255,0.1)', color: 'white',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: 6, padding: '4px 10px', fontSize: 12,
            cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
            transition: 'background 0.2s',
          }}
            onMouseEnter={e => e.target.style.background = 'rgba(216,90,48,0.3)'}
            onMouseLeave={e => e.target.style.background = 'rgba(255,255,255,0.1)'}
          >
            Sair
          </button>
        </div>
      </div>

      {/* ABAS */}
      <div style={{
        background: 'white', borderBottom: `1px solid ${cores.border}`,
        display: 'flex', padding: '0 8px',
        overflowX: 'auto', WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none', msOverflowStyle: 'none'
      }}>
        {(abas || []).map(aba => (
          <div key={aba.key} onClick={() => onAba(aba.key)} style={{
            padding: '12px 14px', fontSize: 13,
            fontWeight: abaAtiva === aba.key ? 600 : 500,
            color: abaAtiva === aba.key ? cores.orange : cores.muted,
            borderBottom: abaAtiva === aba.key ? `2.5px solid ${cores.orange}` : '2.5px solid transparent',
            cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap',
            flexShrink: 0
          }}>
            {aba.label}
          </div>
        ))}
      </div>

      {/* CONTEUDO */}
      <div style={{
        flex: 1, padding: isMobile ? '12px' : '24px',
        maxWidth: 900, margin: '0 auto',
        width: '100%', boxSizing: 'border-box'
      }}>
        {children}
      </div>
    </div>
  );
}
